import { render, staticRenderFns } from "./SendHistory.vue?vue&type=template&id=1c7aaddc&scoped=true"
import script from "./SendHistory.vue?vue&type=script&lang=ts"
export * from "./SendHistory.vue?vue&type=script&lang=ts"
import style0 from "./SendHistory.vue?vue&type=style&index=0&id=1c7aaddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7aaddc",
  null
  
)

export default component.exports